import { LocalDate } from "@js-joda/core";

//! @ngInject
export function signPhysicianDocumentModalCtrl ($scope, $uibModalInstance, DatabaseApi, toaster, apiErrors, dateUtils) {
      $scope.form = {
        signDate: dateUtils.ymdStringToDate(LocalDate.now().toJSON()),
      };

      $scope.submit = () => {
        if ($scope.form.signDate === null) {
          toaster.pop("error", "Error", "Please select a date");
        }

        const body = {
          signDate: dateUtils.dateToLocalDate($scope.form.signDate),
        };

        const url =
          "agencies/:agencyId/agency_members/:agencyMemberId/patient_documents/:patientDocumentId/sign_physician_document"
            .replace(":agencyId", $scope.agencyId)
            .replace(":agencyMemberId", $scope.agencyMemberId)
            .replace(":patientDocumentId", $scope.$resolve.document.id);

        $scope.isLoading = true;
        DatabaseApi.put(url, body)
          .then((response) => {
            $scope.$resolve.onSuccess?.(response.data.document);
            toaster.pop("success", "Success", "Marked as sent");
            $uibModalInstance.close();
          })
          .catch((error) => {
            console.error(error);
            toaster.pop(
              "error",
              "Something went wrong",
              apiErrors.format(error, "Failed to sign physician document")
            );
          })
          .finally(() => ($scope.isLoading = false));
      };

      $scope.close = () => {
        $uibModalInstance.close();
      };
    }
